import { gql } from '@apollo/client';

export const QUERY_GET_DOCTOR_BILLING_BY_DATES = gql`
  query QUERY_GET_DOCTOR_BILLING_BY_DATES($initialDate: timestamptz, $finalDate: timestamptz, $doctorsIds: [uuid!]!) {
    doctorBilling(where: {date: {_gte: $initialDate, _lte: $finalDate}, doctorId: {_in: $doctorsIds}}) {
      date
      daysOfData
      description
      doctorId
      doctorName
      durationLogged
      id
      patientName
      provider
      userId
      address
      birthdate
      phone
      countryPhoneId
      securityCode
      country {
        id
        phonecode
        name
      }
    }
  }
`;

export const QUERY_GET_DOCTOR_BILLING_BY_DATES_COUNT = gql`
  query QUERY_GET_DOCTOR_BILLING_BY_DATES_COUNT($initialDate: timestamptz, $finalDate: timestamptz, $doctorsIds: [uuid!]!) {
    doctorBilling_aggregate(where: {date: {_gte: $initialDate, _lte: $finalDate}, doctorId: {_in: $doctorsIds}}) {
      aggregate {
        count
      }
    }
  }
`